var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('CookieChoice'),_c('Header',{attrs:{"msg":"Header"}}),_c('HomePage',{attrs:{"tipoutilizzo":_vm.tipoutilizzo,"msg":"Body"}}),_c('Footer',{attrs:{"msg":"Footer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }